import React, { PropTypes } from 'react';

import { connect } from 'react-redux';

import SingleSelect from '../single-select/SingleSelect';

import Filter from '../Filter';


import {getFilterCountries} from "../../../../utils/globalSelectors";

class CountryFilter extends Filter {
  static getLabel(filter) {
    super.getLabel(filter);
  }

  render() {
    const { filter, action, countries } = this.props;
    const options = countries.map(country => ({ label: country.title, value: country.id }));

    const newFilter = { ...filter, options, mandatory: true };

    return <SingleSelect action={action} filter={newFilter} />;
  }
}

CountryFilter.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired,
  countries: PropTypes.array
};

const mapStateToProps = state => {
  return {
    countries: getFilterCountries(state)
  };
};

export default connect(mapStateToProps, null)(CountryFilter);



// WEBPACK FOOTER //
// ./src/components/filter/filters/country/Country.js